<!-- 辅导信息详情 -->
<template>
  <div class="mentee-detail">
    <div class="mentee-detail-avatar">
      <img :src="menteeDetail.headPortrait || MenteeAvatar"
           alt="头像">
    </div>
    <div class="info-large">
      <h1>{{menteeDetail.firstName}} {{menteeDetail.lastName}}</h1>
      <span>{{menteeDetail.inYear}}</span>
    </div>
    <div class="info-small">
      <h2>{{menteeDetail.applyField && menteeDetail.applyField.replace('-undefined', '')}}</h2>
      <span>{{menteeDetail.packageName}}</span>
    </div>
  </div>
</template>

<script>
// api
import { getMenteeDetail } from '@/api/mentee'
// images
import MenteeAvatar from '@/assets/images/home/mentee-avatar.svg'
import { mapMutations } from 'vuex'
export default {
  name: 'mentee-detail',
  props: ['id'],
  components: {},
  data () {
    return {
      MenteeAvatar,
      menteeDetail: {}

    }
  },
  computed: {},
  mounted () {
    this.getMenteeDetail()
  },
  methods: {
    ...mapMutations(['setMenteeDetail']),
    getMenteeDetail () {
      getMenteeDetail({
        num: this.id
      }).then(res => {
        this.menteeDetail = res.data.model
        this.setMenteeDetail(res.data.model)
      })
    }
  },
  watch: {
    id () {
      this.getMenteeDetail()
    }
  }
}
</script>
<style lang='less' scoped>
</style>
